module.exports = __webpack_public_path__ + "static/media/camera.a0dcda33.svg";